import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import LDAPSearchViewModelType from '@/ViewModels/Controls/LDAPSearchViewModel';
import PropertyGroupBoxType from '@/Controls/PropertyGroupBox';

export default class LDAPSearch extends Control {

    private PropertyGroupBox = ComponentManager.getControl<typeof PropertyGroupBoxType>('PropertyGroupBox');
    private jQueryControl: JQuery;
    private propertyGroupBox: PropertyGroupBoxType;

    public constructor(private viewModel: LDAPSearchViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'ldapsearch',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible
        });

        if (this.viewModel.propertyGroupBox != null) {
            this.propertyGroupBox = new this.PropertyGroupBox(this.viewModel.propertyGroupBox);
            this.viewModel.executeBusilyAsync(async () => {
                const tuple = await this.propertyGroupBox.getTupleAsync();
                tuple.control.appendTo(this.jQueryControl);
            });
        }
    }
}

ComponentManager.setControl('LDAPSearch', LDAPSearch, 'RADPresentation.HTMLClient.DefaultViewExtensions');